const EVENTS_TYPES = {
    PDP: 'pdp_visit',
    ADD_TO_CART: 'add_to_cart',
    MEMBERSHIP: 'membership_registration',
    PURCHASE: 'purchase'
};
/**
 * Push the data of an Optimizely event to Optimizely
 *
 * @param {string} eventType - Event type
 * @param {string} revenue - revenue value
 * @param {string} value -
 * @returns {void}
 */
function pushEventToOptimizely(eventType, revenue, value) {
    const tags = {};
    const data = {
        type: 'event',
        eventName: EVENTS_TYPES[eventType]
    };

    if (revenue) {
        tags.revenue = revenue * 100;
    }
    if (value) {
        tags.value = value;
    }

    if (tags.revenue || tags.value) {
        data.tags = tags;
    }

    if (window.optimizely) {
        window.optimizely.push(data);
    }
}

exports.pushEventToOptimizely = pushEventToOptimizely;
